import {useParams} from "react-router-dom";
import {StepByStep} from "./StepByStep.tsx";

export function StepByStepPage() {

    const {jobId} = useParams();
    return <StepByStep jobId={jobId}/>

}